import { EZoneCategory } from '@ixicare/resources';
import { FormField } from '@ixicare/ui';
import React from 'react';
import Select from 'react-select';
import { t } from '~i18n';

type TProps = {
  onChange: (category?: EZoneCategory) => void;
  category?: EZoneCategory;
};

export function ZoneCategorySelect({ category, onChange }: TProps) {
  const options = Object.values(EZoneCategory)
    .filter((value) => value !== EZoneCategory.Other)
    .map((value) => ({
      label: t(`zone.category.${value}`),
      value,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const value = React.useMemo(() => options?.find((x) => x.value === category) ?? null, [category, options]);

  return (
    <FormField label="Category">
      <Select isMulti={false} value={value} options={options} onChange={(option) => onChange(option?.value)} />
    </FormField>
  );
}
